import { createActions } from 'redux-actions';

import types from 'state/orders/actionTypes';

const { orders } = createActions({
  [types.fetchOrders$]: ({ type }) => ({ type }),
  [types.fetchOrdersStartPolling$]: ({ type }) => ({ type }),
  [types.fetchOrdersStopPolling$]: () => {},
  [types.fetchMoreOrders$]: ({ type }) => ({ type }),
  [types.updateFilters$]: ({ type, filter }) => ({ type, filter }),

  [types.openOrder$]: ({ orderId, type }) => ({ orderId, type }),
  [types.closeOrder$]: ({ type }) => ({ type }),
  [types.updateInternalReference$]: ({
    internalReference,
    shipmentId,
    orderId,
  }) => ({
    internalReference,
    shipmentId,
    orderId,
  }),

  [types.UPDATE_SHIPMENT]: ({ shipment, shipmentId, orderId }) => ({
    shipment,
    shipmentId,
    orderId,
  }),

  [types.RESET_DATA]: () => ({}),
  [types.SET_DATA]: ({ data }) => ({ data }),
  [types.ADD_DATA]: ({ data }) => ({ data }),

  [types.SET_FILTER]: ({ filters }) => ({ filters }),

  [types.SET_PAGE]: ({ pages }) => ({ pages }),
  [types.RESET_PAGE]: () => ({}),

  [types.SET_FETCHING]: (isFetching) => ({ isFetching }),
  [types.SET_SUBMITTING]: (isSubmitting) => ({ isSubmitting }),

  [types.searchByText$]: ({ pathname, text }) => ({ pathname, text }),
  [types.SET_SEARCH_TEXT]: (text) => ({ text }),

  [types.setUserFilter$]: ({ user, pathname }) => ({ user, pathname }),
  [types.clearUserFilter$]: ({ pathname }) => ({ pathname }),
  [types.SET_USER]: (user) => ({ user }),
  [types.CLEAR_USER]: () => ({}),

  [types.setDateFilter$]: ({ type, value, pathname }) => ({
    type,
    value,
    pathname,
  }),
  [types.clearDateFilter$]: ({ type, pathname }) => ({ type, pathname }),
  [types.clearDatesFilter$]: ({ pathname }) => ({ pathname }),

  [types.SET_DATE]: ({ type, value }) => ({ type, value }),
  [types.CLEAR_DATE]: ({ type }) => ({ type }),

  [types.cancelOrder$]: ({ order, reason, comment }) => ({
    order,
    reason,
    comment,
  }),
});

export default orders;
